import React, { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Box, Typography } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";

import _request from "actions/_request";
import i18n from "i18";

import "./style.css";

const StripeFailed = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;

    const params = Object.fromEntries(searchParams.entries());
    _request.stripe.failed(params).catch(() => {});
  }, [searchParams]);

  const tr = (key) => i18n.t("stripe." + key);

  return (
    <Box className="flex flex1 centerH centerV">
      <Box className="stripe-result-card">
        <HighlightOffIcon className="stripe-result-icon stripe-result-icon--failed" />

        <Typography className="stripe-result-title">
          {tr("failedTitle")}
        </Typography>

        <Typography className="stripe-result-desc">
          {tr("failedDesc")}
        </Typography>

        <Box className="stripe-result-actions">
          <Box
            className="stripe-result-btn stripe-result-btn--primary"
            onClick={() => navigate("/app/pricing")}>
            {tr("tryAgain")}
          </Box>
          <Box
            className="stripe-result-btn stripe-result-btn--secondary"
            onClick={() => navigate("/app/dashboard")}>
            {tr("goDashboard")}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default StripeFailed;
